<template lang="pug">
	BaseModal.alert-modal(
		v-if="isOpen"
	)
		template(v-slot:body)
			.top
				.warning-container
					IconAlert.icon-alert
					p.warning-text Warning
				p.explanation-text {{ message }}
			.middle
				p.course-name(v-for="item in items") {{ item }}
			.bottom
				div.button(class="cancel-button" @click="$emit('cancel')") Cancel
				div.button(class="accept-button" @click="$emit('accept')") Okay
</template>

<script>
import BaseModal from '@/components/BaseModal';
import IconAlert from '@/components/IconAlert';

export default {
  name       : 'program-alert-modal',
  components : {
    BaseModal,
    IconAlert
  },

  props : {
    isOpen  : Boolean,
    message : String,
    items   : Array
  },
};
</script>

<style lang="scss" scoped>
.alert-modal {
	background-color: rgba(0, 0, 0, 0.8);

	&::v-deep .modal {
		width: 600px;
		min-height: 400px;
		max-height: 90vh;
		overflow: auto;

		.modal-body  {
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 30px;

			.top {
				.warning-container {
					display: flex;
					flex-direction: column;
					align-items: center;

					.icon-alert {
						color: red;
						width: 90px;
					}

					.warning-text {
						text-transform: uppercase;
						color: $cancel;
						font-weight: 700;
						font-size: 20px;
						letter-spacing: 2px;
					}
				}

				.explanation-text {
					text-align: center;
					margin-top: 5px;
				}
			}

			.middle {
				margin: 15px 0;

				.course-name {
					font-size: 18px;
					text-align: center;
					font-weight: 500;

					&:not(:last-child) {
						margin-bottom: 8px;
					}
				}
			}

			.bottom {
				display: flex;
				justify-content: center;
				margin-top: auto;
				padding-top: 30px;

				.button {
					width: 100px;
				}
				.cancel-button {
					margin-right: 30px;
					background-color: #D1D6DF;
					color: #36548D;
				}
			}
		}
	}

}
</style>
